const images = {
	"logo": require("./logo.png"),
	"pdf": require("./pdf.png"),
	"info": require("./info.png"),
	"carDesignImg": require("./car-design-img.png"),
	"marker": require("./marker.png"),
};

export default images;
